import { WorkspaceSections } from '@/pages/Workspace/types';

function getWorkspaceSection(path: string): WorkspaceSections {
  return Object.values(WorkspaceSections).find((section) => path.startsWith(`/${section}`));
}

export { getWorkspaceSection };
